/**
 * @generated SignedSource<<b0a7db5f6166bccb79ee9636dd1248b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CatalogDocument_catalogPage$data = {
  readonly file: {
    readonly filePath: string | null;
  } | null;
  readonly images: {
    readonly singlePageDimensions: {
      readonly height: number;
      readonly width: number;
    };
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogOverview_catalogPage" | "CatalogPageNumber_catalogPage" | "CatalogPage_catalogPage">;
  readonly " $fragmentType": "CatalogDocument_catalogPage";
};
export type CatalogDocument_catalogPage$key = {
  readonly " $data"?: CatalogDocument_catalogPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogDocument_catalogPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CatalogDocument_catalogPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CatalogFileModuleType",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filePath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CatalogImagesType",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CatalogImagesDimensions",
          "kind": "LinkedField",
          "name": "singlePageDimensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CatalogPageNumber_catalogPage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CatalogPage_catalogPage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CatalogOverview_catalogPage"
    }
  ],
  "type": "CatalogPage",
  "abstractKey": null
};

(node as any).hash = "15b406c28550e0a397a7001fcbfd3765";

export default node;
